export default {
  canvas: {
    _skip: 0,
    backgroundColor: "rgba(10, 24, 39, 1)",
    backgroundImage: "",
    backgroundSize: "cover",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "rgba(66, 66, 66, 1)",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    childDelay: 0,
    children: [
      "element_emptycontainerf0e2f360-ddd4-11e7-9b9b-71de79cb9cac",
      "element_textb7e77a70-ddd6-11e7-9ca2-594983b35b33",
      "element_text2f2b1830-ddd7-11e7-9ca2-594983b35b33",
      "element_emptycontainerc7f70010-ddd7-11e7-a5ed-25edf8e70428",
      "element_text8e8f7450-ddd8-11e7-a5ed-25edf8e70428",
      "element_emptycontainerdc1dc630-ddd9-11e7-a7da-ff08193cd844",
      "element_emptycontainerf77178a0-ddd9-11e7-a7da-ff08193cd844",
      "element_emptycontainerf9af5ab0-ddd9-11e7-a7da-ff08193cd844"
    ],
    collection: "none",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    gradient: "",
    height: 600,
    hideOverflow: false,
    id: "canvas",
    label: "TwitchIntro",
    leaveAnimation: "none",
    left: 0,
    limit: 10,
    maximum: 100,
    opacity: 1,
    perspective: 150,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 10,
    stayDuration: 7000,
    streamHeight: 9,
    streamWidth: 16,
    top: 0,
    transformOrigin: "50% 50% 0",
    type: "element_emptycontainer",
    width: 600,
    rules: []
  },
  "element_emptycontainerc7f70010-ddd7-11e7-a5ed-25edf8e70428": {
    _skip: 0,
    backgroundColor: "rgba(91, 148, 150, 0)",
    backgroundImage: "",
    backgroundSize: "contain",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "rgba(91, 148, 150, 1)",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0.0030156815440289505,
    childDelay: 0,
    children: ["element_progressbarf68b2230-ddd7-11e7-a5ed-25edf8e70428"],
    collection: "none",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    gradient: "",
    height: 0.023182297154899896,
    hideOverflow: false,
    id: "element_emptycontainerc7f70010-ddd7-11e7-a5ed-25edf8e70428",
    label: "Progress",
    leaveAnimation: "none",
    left: 0.5465922798552474,
    limit: 10,
    maximum: 100,
    opacity: 1,
    parent: "canvas",
    perspective: 0.11308805790108564,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.007539203860072375,
    stayDuration: 7000,
    top: 0.5085295485947366,
    transformOrigin: "50% 50% 0",
    type: "element_emptycontainer",
    width: 0.37091675447839834,
    rules: []
  },
  "element_emptycontainerdc1dc630-ddd9-11e7-a7da-ff08193cd844": {
    _skip: 0,
    backgroundColor: "rgba(91, 148, 150, 0.06)",
    backgroundImage: "",
    backgroundSize: "contain",
    blur: 0,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    borderColor: "#3B4253",
    borderStyle: "solid",
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    borderWidth: 0,
    childDelay: 0,
    children: [
      "element_textdff72fd0-ddd9-11e7-a7da-ff08193cd844",
      "element_icone4a72350-ddd9-11e7-a7da-ff08193cd844"
    ],
    collection: "none",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    gradient: "",
    height: 0.08008429926238145,
    hideOverflow: false,
    id: "element_emptycontainerdc1dc630-ddd9-11e7-a7da-ff08193cd844",
    label: "Twitter",
    leaveAnimation: "none",
    left: 0.571471652593486,
    limit: 10,
    maximum: 100,
    opacity: 1,
    parent: "canvas",
    perspective: 0.11308805790108564,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.007539203860072375,
    stayDuration: 7000,
    top: 0.08673579960367142,
    transformOrigin: "50% 50% 0",
    type: "element_emptycontainer",
    width: 0.30031612223393045,
    rules: []
  },
  "element_emptycontainerf0e2f360-ddd4-11e7-9b9b-71de79cb9cac": {
    _skip: 0,
    backgroundColor: "transparent",
    backgroundImage: "",
    backgroundSize: "contain",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "rgba(91, 148, 150, 1)",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0.0030156815440289505,
    childDelay: 0,
    children: [
      "element_textd45ebac0-ddd5-11e7-9b9b-71de79cb9cac",
      "element_text221c9d90-ddd6-11e7-8406-d7e7d15c1b4b",
      "element_icon611f4ab0-ddd6-11e7-8406-d7e7d15c1b4b"
    ],
    collection: "twitterfeed.tweets",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "elevator",
    gradient: "",
    height: 0.13066385669125394,
    hideOverflow: false,
    id: "element_emptycontainerf0e2f360-ddd4-11e7-9b9b-71de79cb9cac",
    label: "Tweet",
    leaveAnimation: "none",
    left: 0.09574788902291917,
    limit: 3,
    maximum: 100,
    opacity: 1,
    parent: "canvas",
    perspective: 0.11308805790108564,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.021109770808202654,
    stayDuration: 7000,
    top: 0.09764293822079236,
    transformOrigin: "50% 50% 0",
    type: "element_emptycontainer",
    width: 0.3382507903055848,
    rules: []
  },
  "element_emptycontainerf77178a0-ddd9-11e7-a7da-ff08193cd844": {
    _skip: 0,
    backgroundColor: "rgba(91, 148, 150, 0.06)",
    backgroundImage: "",
    backgroundSize: "contain",
    blur: 0,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    borderColor: "#3B4253",
    borderStyle: "solid",
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    borderWidth: 0,
    childDelay: 0,
    children: [
      "element_textf7719fb0-ddd9-11e7-a7da-ff08193cd844",
      "element_iconf7719fb1-ddd9-11e7-a7da-ff08193cd844"
    ],
    collection: "none",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    gradient: "",
    height: 0.08008429926238145,
    hideOverflow: false,
    id: "element_emptycontainerf77178a0-ddd9-11e7-a7da-ff08193cd844",
    label: "Youtube",
    leaveAnimation: "none",
    left: 0.663449939686369,
    limit: 10,
    maximum: 100,
    opacity: 1,
    parent: "canvas",
    perspective: 0.11308805790108564,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.007539203860072375,
    stayDuration: 7000,
    top: 0.19756209634673533,
    transformOrigin: "50% 50% 0",
    type: "element_emptycontainer",
    width: 0.30031612223393045,
    rules: []
  },
  "element_emptycontainerf9af5ab0-ddd9-11e7-a7da-ff08193cd844": {
    _skip: 0,
    backgroundColor: "rgba(91, 148, 150, 0.06)",
    backgroundImage: "",
    backgroundSize: "contain",
    blur: 0,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    borderColor: "#3B4253",
    borderStyle: "solid",
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    borderWidth: 0,
    childDelay: 0,
    children: [
      "element_textf9af81c0-ddd9-11e7-a7da-ff08193cd844",
      "element_iconf9af81c1-ddd9-11e7-a7da-ff08193cd844"
    ],
    collection: "none",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    gradient: "",
    height: 0.08008429926238145,
    hideOverflow: false,
    id: "element_emptycontainerf9af5ab0-ddd9-11e7-a7da-ff08193cd844",
    label: "Instagram",
    leaveAnimation: "none",
    left: 0.568455971049457,
    limit: 10,
    maximum: 100,
    opacity: 1,
    parent: "canvas",
    perspective: 0.11308805790108564,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.007539203860072375,
    stayDuration: 7000,
    top: 0.3053727115457704,
    transformOrigin: "50% 50% 0",
    type: "element_emptycontainer",
    width: 0.30031612223393045,
    rules: []
  },
  "element_icon611f4ab0-ddd6-11e7-8406-d7e7d15c1b4b": {
    _skip: 0,
    backgroundColor: "transparent",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#dddddd",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    color: "rgba(91, 148, 150, 1)",
    delay: 0,
    enterAnimation: "none",
    height: 0.0180940892641737,
    icon: "twitter",
    id: "element_icon611f4ab0-ddd6-11e7-8406-d7e7d15c1b4b",
    label: "Icon",
    leaveAnimation: "none",
    left: 0.014324487334137503,
    limit: 10,
    lockAspectRatio: true,
    maximum: 100,
    opacity: 1,
    parent: "element_emptycontainerf0e2f360-ddd4-11e7-9b9b-71de79cb9cac",
    perspective: 0.11308805790108564,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    stayDuration: 7000,
    top: 0.012062726176115802,
    transformOrigin: "50% 50% 0",
    type: "element_icon",
    width: 0.0180940892641737,
    rules: [],
    children: []
  },
  "element_icone4a72350-ddd9-11e7-a7da-ff08193cd844": {
    _skip: 0,
    backgroundColor: "transparent",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#dddddd",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    color: "rgba(91, 148, 150, 1)",
    delay: 0,
    enterAnimation: "none",
    height: 0.045235223160434254,
    icon: "twitter",
    id: "element_icone4a72350-ddd9-11e7-a7da-ff08193cd844",
    label: "Icon",
    leaveAnimation: "none",
    left: 0.03166465621230398,
    limit: 10,
    lockAspectRatio: true,
    maximum: 100,
    opacity: 1,
    parent: "element_emptycontainerdc1dc630-ddd9-11e7-a7da-ff08193cd844",
    perspective: 0.11308805790108564,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    stayDuration: 7000,
    top: 0.016586248492159228,
    transformOrigin: "50% 50% 0",
    type: "element_icon",
    width: 0.045235223160434254,
    rules: [],
    children: []
  },
  "element_iconf7719fb1-ddd9-11e7-a7da-ff08193cd844": {
    _skip: 0,
    backgroundColor: "transparent",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#dddddd",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    color: "rgba(91, 148, 150, 1)",
    delay: 0,
    enterAnimation: "none",
    height: 0.045235223160434254,
    icon: "youtube-play",
    id: "element_iconf7719fb1-ddd9-11e7-a7da-ff08193cd844",
    label: "Icon",
    leaveAnimation: "none",
    left: 0.03166465621230398,
    limit: 10,
    lockAspectRatio: true,
    maximum: 100,
    opacity: 1,
    parent: "element_emptycontainerf77178a0-ddd9-11e7-a7da-ff08193cd844",
    perspective: 0.11308805790108564,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    stayDuration: 7000,
    top: 0.016586248492159228,
    transformOrigin: "50% 50% 0",
    type: "element_icon",
    width: 0.045235223160434254,
    rules: [],
    children: []
  },
  "element_iconf9af81c1-ddd9-11e7-a7da-ff08193cd844": {
    _skip: 0,
    backgroundColor: "transparent",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#dddddd",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    color: "rgba(91, 148, 150, 1)",
    delay: 0,
    enterAnimation: "none",
    height: 0.045235223160434254,
    icon: "instagram",
    id: "element_iconf9af81c1-ddd9-11e7-a7da-ff08193cd844",
    label: "Icon",
    leaveAnimation: "none",
    left: 0.03166465621230398,
    limit: 10,
    lockAspectRatio: true,
    maximum: 100,
    opacity: 1,
    parent: "element_emptycontainerf9af5ab0-ddd9-11e7-a7da-ff08193cd844",
    perspective: 0.11308805790108564,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    stayDuration: 7000,
    top: 0.016586248492159228,
    transformOrigin: "50% 50% 0",
    type: "element_icon",
    width: 0.045235223160434254,
    rules: [],
    children: []
  },
  "element_progressbarf68b2230-ddd7-11e7-a5ed-25edf8e70428": {
    _skip: 0,
    backgroundColor: "rgba(91, 148, 150, 1)",
    backgroundImage: "",
    backgroundSize: "contain",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#3B4253",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    childDelay: 0,
    collection: "none",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    gradient: "",
    height: 0.014752370916754479,
    hideOverflow: false,
    id: "element_progressbarf68b2230-ddd7-11e7-a5ed-25edf8e70428",
    label: "Progress Bar",
    leaveAnimation: "none",
    left: 0.0015078407720144752,
    limit: 10,
    maximum: 100,
    opacity: 1,
    orientation: "horizontal",
    parent: "element_emptycontainerc7f70010-ddd7-11e7-a5ed-25edf8e70428",
    perspective: 0.11308805790108564,
    progress: {
      target: "countdown.progress"
    },
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.007539203860072375,
    stayDuration: 7000,
    top: 0.0015078407720144752,
    transformOrigin: "50% 50% 0",
    type: "element_progressbar",
    width: 0.36143308746048475,
    rules: [],
    children: []
  },
  "element_text221c9d90-ddd6-11e7-8406-d7e7d15c1b4b": {
    _skip: 0,
    alignItems: "center",
    backgroundColor: "transparent",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#dddddd",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    collection: "none",
    color: "rgba(91, 148, 150, 1)",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    fontFamily: "Oswald",
    fontSize: 0.01507840772014475,
    fontStyle: "normal",
    fontWeight: 400,
    height: 0.08066948130277442,
    id: "element_text221c9d90-ddd6-11e7-8406-d7e7d15c1b4b",
    label: "Text",
    leaveAnimation: "none",
    left: 0.013570566948130277,
    letterSpacing: 0,
    limit: 10,
    lineHeight: 1.2,
    maxItems: 1,
    maximum: 100,
    minHeight: 20,
    minWidth: 20,
    opacity: 1,
    parent: "element_emptycontainerf0e2f360-ddd4-11e7-9b9b-71de79cb9cac",
    perspective: 0.11308805790108564,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.007539203860072375,
    stayDuration: 7000,
    text: "{twitterfeed.tweets.text}",
    textAlign: "left",
    textIdent: 0,
    top: 0.0361881785283474,
    transformOrigin: "50% 50% 0",
    type: "element_text",
    width: 0.304583835946924,
    rules: [],
    children: []
  },
  "element_text2f2b1830-ddd7-11e7-9ca2-594983b35b33": {
    _skip: 0,
    alignItems: "center",
    backgroundColor: "transparent",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#dddddd",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    collection: "none",
    color: "rgba(91, 148, 150, 1)",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    fontFamily: "Oswald",
    fontSize: 0.03091073582629674,
    fontStyle: "normal",
    fontWeight: 400,
    height: 0.0547945205479452,
    id: "element_text2f2b1830-ddd7-11e7-9ca2-594983b35b33",
    label: "Starting",
    leaveAnimation: "none",
    left: 0.5835343787696017,
    letterSpacing: 2,
    limit: 10,
    lineHeight: 1.5,
    maxItems: 1,
    maximum: 100,
    minHeight: 20,
    minWidth: 20,
    opacity: 1,
    parent: "canvas",
    perspective: 0.11308805790108564,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.007539203860072375,
    stayDuration: 7000,
    text: "starting in",
    textAlign: "right",
    textIdent: 0,
    top: 0.4415849138385781,
    transformOrigin: "50% 50% 0",
    type: "element_text",
    width: 0.18018967334035826,
    rules: [],
    children: []
  },
  "element_text8e8f7450-ddd8-11e7-a5ed-25edf8e70428": {
    _skip: 0,
    alignItems: "center",
    backgroundColor: "transparent",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#dddddd",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    collection: "none",
    color: "rgba(91, 148, 150, 1)",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    fontFamily: "Oswald",
    fontSize: 0.023371531966224365,
    fontStyle: "normal",
    fontWeight: 400,
    height: 0.02528977871443625,
    id: "element_text8e8f7450-ddd8-11e7-a5ed-25edf8e70428",
    label: "Countdown",
    leaveAnimation: "none",
    left: 0.772014475271411,
    letterSpacing: 2,
    limit: 10,
    lineHeight: 1.5,
    maxItems: 1,
    maximum: 100,
    minHeight: 20,
    minWidth: 20,
    opacity: 1,
    parent: "canvas",
    perspective: 0.11308805790108564,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.007539203860072375,
    stayDuration: 7000,
    text: "{countdown.minute}:{countdown.second}",
    textAlign: "left",
    textIdent: 0,
    top: 0.4596790031027518,
    transformOrigin: "50% 50% 0",
    type: "element_text",
    width: 0.1475237091675448,
    rules: [],
    children: []
  },
  "element_textb7e77a70-ddd6-11e7-9ca2-594983b35b33": {
    _skip: 0,
    alignItems: "center",
    backgroundColor: "transparent",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#dddddd",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    collection: "none",
    color: "rgba(91, 148, 150, 1)",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    fontFamily: "Oswald",
    fontSize: 0.03091073582629674,
    fontStyle: "normal",
    fontWeight: 400,
    height: 0.0874604847207587,
    id: "element_textb7e77a70-ddd6-11e7-9ca2-594983b35b33",
    label: "Hashtag",
    leaveAnimation: "none",
    left: 0.04379157287017882,
    letterSpacing: 4,
    limit: 10,
    lineHeight: 1.5,
    maxItems: 1,
    maximum: 100,
    minHeight: 20,
    minWidth: 20,
    opacity: 1,
    parent: "canvas",
    perspective: 0.11308805790108564,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.007539203860072375,
    stayDuration: 7000,
    text: "PARTICIPATE ON #twitch",
    textAlign: "center",
    textIdent: 0,
    textOverflow: "wrap",
    top: 0.005175595922823976,
    transformOrigin: "50% 50% 0",
    type: "element_text",
    width: 0.47629083245521603,
    rules: [],
    children: []
  },
  "element_textd45ebac0-ddd5-11e7-9b9b-71de79cb9cac": {
    _skip: 0,
    alignItems: "center",
    backgroundColor: "transparent",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#dddddd",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    collection: "none",
    color: "rgba(91, 148, 150, 1)",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    fontFamily: "Oswald",
    fontSize: 0.01884800965018094,
    fontStyle: "normal",
    fontWeight: 400,
    height: 0.02186369119420989,
    id: "element_textd45ebac0-ddd5-11e7-9b9b-71de79cb9cac",
    label: "User",
    leaveAnimation: "none",
    left: 0.04221954161640531,
    letterSpacing: 0,
    limit: 10,
    lineHeight: 1.2,
    maxItems: 1,
    maximum: 100,
    minHeight: 20,
    minWidth: 20,
    opacity: 1,
    parent: "element_emptycontainerf0e2f360-ddd4-11e7-9b9b-71de79cb9cac",
    perspective: 0.11308805790108564,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.007539203860072375,
    stayDuration: 7000,
    text: "{twitterfeed.tweets.name}",
    textAlign: "left",
    textIdent: 0,
    top: 0.008293124246079614,
    transformOrigin: "50% 50% 0",
    type: "element_text",
    width: 0.2766887816646562,
    rules: [],
    children: []
  },
  "element_textdff72fd0-ddd9-11e7-a7da-ff08193cd844": {
    _skip: 0,
    alignItems: "center",
    backgroundColor: "transparent",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#dddddd",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    collection: "none",
    color: "rgba(91, 148, 150, 1)",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    fontFamily: "Oswald",
    fontSize: 0.03091073582629674,
    fontStyle: "normal",
    fontWeight: 400,
    height: 0.039203860072376355,
    id: "element_textdff72fd0-ddd9-11e7-a7da-ff08193cd844",
    label: "Text",
    leaveAnimation: "none",
    left: 0.10705669481302774,
    letterSpacing: 4,
    limit: 10,
    lineHeight: 1.5,
    maxItems: 1,
    maximum: 100,
    minHeight: 20,
    minWidth: 20,
    opacity: 1,
    parent: "element_emptycontainerdc1dc630-ddd9-11e7-a7da-ff08193cd844",
    perspective: 0.11308805790108564,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.007539203860072375,
    stayDuration: 7000,
    text: "{twitch.name}",
    textAlign: "left",
    textIdent: 0,
    top: 0.0180940892641737,
    transformOrigin: "50% 50% 0",
    type: "element_text",
    width: 0.17566344993968636,
    rules: [],
    children: []
  },
  "element_textf7719fb0-ddd9-11e7-a7da-ff08193cd844": {
    _skip: 0,
    alignItems: "center",
    backgroundColor: "transparent",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#dddddd",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    collection: "none",
    color: "rgba(91, 148, 150, 1)",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    fontFamily: "Oswald",
    fontSize: 0.03091073582629674,
    fontStyle: "normal",
    fontWeight: 400,
    height: 0.039203860072376355,
    id: "element_textf7719fb0-ddd9-11e7-a7da-ff08193cd844",
    label: "Text",
    leaveAnimation: "none",
    left: 0.08594692400482508,
    letterSpacing: 4,
    limit: 10,
    lineHeight: 1.5,
    maxItems: 1,
    maximum: 100,
    minHeight: 20,
    minWidth: 20,
    opacity: 1,
    parent: "element_emptycontainerf77178a0-ddd9-11e7-a7da-ff08193cd844",
    perspective: 0.11308805790108564,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.007539203860072375,
    stayDuration: 7000,
    text: "{twitch.name}",
    textAlign: "center",
    textIdent: 0,
    top: 0.016586248492159228,
    transformOrigin: "50% 50% 0",
    type: "element_text",
    width: 0.18923401688781663,
    rules: [],
    children: []
  },
  "element_textf9af81c0-ddd9-11e7-a7da-ff08193cd844": {
    _skip: 0,
    alignItems: "center",
    backgroundColor: "transparent",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#dddddd",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    collection: "none",
    color: "rgba(91, 148, 150, 1)",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    fontFamily: "Oswald",
    fontSize: 0.03091073582629674,
    fontStyle: "normal",
    fontWeight: 400,
    height: 0.044481302774427016,
    id: "element_textf9af81c0-ddd9-11e7-a7da-ff08193cd844",
    label: "Text",
    leaveAnimation: "none",
    left: 0.08594692400482508,
    letterSpacing: 4,
    limit: 10,
    lineHeight: 1.5,
    maxItems: 1,
    maximum: 100,
    minHeight: 20,
    minWidth: 20,
    opacity: 1,
    parent: "element_emptycontainerf9af5ab0-ddd9-11e7-a7da-ff08193cd844",
    perspective: 0.11308805790108564,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.007539203860072375,
    stayDuration: 7000,
    text: "{twitch.name}",
    textAlign: "center",
    textIdent: 0,
    top: 0.01507840772014475,
    transformOrigin: "50% 50% 0",
    type: "element_text",
    width: 0.18923401688781663,
    rules: [],
    children: []
  }
};



// WEBPACK FOOTER //
// ./src/constants/templates/twitterIdle.js